var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltipInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "INFO",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6F7072",
    id: "Oval-3"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.5,
    opacity: 0.304234601,
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.6,
    cx: 13,
    cy: 13,
    r: 9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.000000, 9.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8246875,0 C3.34265625,0 3.7621875,0.41953125 3.7621875,0.9375 C3.7621875,1.45546875 3.34265625,1.875 2.8246875,1.875 C2.30671875,1.875 1.8871875,1.45546875 1.8871875,0.9375 C1.8871875,0.41953125 2.30671875,0 2.8246875,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65109375,7.9903125 C2.7984375,8.3259375 2.54953125,8.4375 2.00203125,8.4375 C1.55484375,8.4375 1.20703125,8.32828125 0.9590625,8.1103125 C0.46921875,7.6790625 0.55171875,7.0565625 0.705,6.4190625 L1.16625,4.78640625 C1.2553125,4.4503125 1.43578125,3.76359375 1.183125,3.52265625 C0.93046875,3.28171875 0.3421875,3.4340625 4.36539693e-13,3.5615625 L0.12328125,3.05859375 C0.61734375,2.8575 1.24171875,2.61140625 1.7746875,2.61140625 C2.57625,2.61140625 3.16265625,3.0121875 3.16265625,3.76875 C3.16265625,3.83953125 3.15421875,3.96421875 3.1378125,4.14328125 C3.106875,4.471875 3.0975,4.4503125 2.585625,6.2625 C2.5284375,6.46171875 2.43984375,6.885 2.43984375,7.08984375 C2.43984375,7.87875 3.3571875,7.68375 3.774375,7.486875 L3.65109375,7.9903125 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipInfo);
export default __webpack_public_path__ + "static/media/tooltipInfo.a5c7182b9ce3cf56426fdc06bf8e1f71.svg";
export { ForwardRef as ReactComponent };